import { FieldPresetType } from '@/catalog/constants/fieldPresetTypes';

import SetupPreset from './SetupPreset';

export enum SetupPresetGroupType {
  Aset = 1,
  TableColorLab = 4,
  PavColorLab = 5,
  Macbeth = 6,
  Darkfield = 7,
  Office = 11,
  FlourTable = 12,
  FlourSide = 13,
  Swinging = 14,
  FullRotation = 15,
  ViBOX = 16,
  FireDiBOX = 17,
  GrETag = 18,
  TableColorUVFree = 19,
  PavColorUVFree = 20,
  CustomLightings = 22,
  DeadZone = 109,
}

export const SETUP_PRESET_GROUP_ASET = SetupPresetGroupType.Aset;
export const SETUP_PRESET_GROUP_MACBETH = SetupPresetGroupType.Macbeth;
export const SETUP_PRESET_GROUP_SWINGING = SetupPresetGroupType.Swinging;
export const SETUP_PRESET_GROUP_FULL_ROTATION = SetupPresetGroupType.FullRotation;
export const SETUP_PRESET_GROUP_VIBOX = SetupPresetGroupType.ViBOX;
export const SETUP_PRESET_GROUP_CUSTOM_LIGHTINGS = SetupPresetGroupType.CustomLightings;

export const SETUP_PRESET_GROUP_OFFICE = SetupPresetGroupType.Office;
export const SETUP_PRESET_GROUP_FIRE_DIBOX = SetupPresetGroupType.FireDiBOX;

export const SETUP_PRESET_GROUP_DARKFIELD = SetupPresetGroupType.Darkfield;
export const SETUP_PRESET_GROUP_TABLE_COLOR_LAB = SetupPresetGroupType.TableColorLab;
export const SETUP_PRESET_GROUP_PAV_COLOR_LAB = SetupPresetGroupType.PavColorLab;
export const SETUP_PRESET_GROUP_TABLE_COLOR_UVFREE = SetupPresetGroupType.TableColorUVFree;
export const SETUP_PRESET_GROUP_PAV_COLOR_UVFREE = SetupPresetGroupType.PavColorUVFree;
export const SETUP_PRESET_GROUP_FLUOR_TABLE = SetupPresetGroupType.FlourTable;
export const SETUP_PRESET_GROUP_FLUOR_SIDE = SetupPresetGroupType.FlourSide;

export const SETUP_PRESET_GROUP_GRETAG = SetupPresetGroupType.GrETag;

export const IGNORED_FOR_REFERENCE_COMPARISON = [
  SetupPresetGroupType.FullRotation,
  SetupPresetGroupType.ViBOX,
  SetupPresetGroupType.Darkfield,
  SetupPresetGroupType.TableColorLab,
  SetupPresetGroupType.PavColorLab,
  SetupPresetGroupType.FlourTable,
  SetupPresetGroupType.FlourSide,
];

export const SPG_ORDER_SOLUTION_LIST_DZ = [
  SetupPresetGroupType.Office,
  SetupPresetGroupType.TableColorUVFree,
  SetupPresetGroupType.PavColorUVFree,
  SetupPresetGroupType.Aset,
];

export const SPG_ORDER_SOLUTION_LIST_FANCY_COLOR = [
  SetupPresetGroupType.Office,
  SetupPresetGroupType.TableColorUVFree,
  SetupPresetGroupType.PavColorUVFree,
  SetupPresetGroupType.Aset,
];

export class SetupPresetGroupModel {
  id!: SetupPresetGroupType;
  title!: string;
  // List of related SetupPresets
  sp!: number[];
  // Indicates whether the SetupPresetGroup should be displayed with exact context
  // (for example, different combo tables could have different fields. So we have to hide certain SetupPresetGroups)
  scope!: FieldPresetType[];
  // Indicates whether the Power component is present.
  position!: number;
}

class SetupPresetGroupConstructor extends SetupPresetGroupModel {
  // @ts-ignore
  sp!: Nullable<SetupPreset>[];
}

/**
 * Entity for composition of different setup presets.
 *
 * For example, we merge Fire and Fire Live Photo in one SetupPresetGroup.
 *
 * If product doesn't have Fire video then Fire Live Photo will be displayed
 */
export default class SetupPresetGroup extends SetupPresetGroupConstructor {
  sp: Nullable<SetupPreset>[] = [];

  constructor(modelData: SetupPresetGroupConstructor) {
    super();

    this.id = modelData.id;
    this.position = modelData.position;
    this.scope = modelData.scope;
    this.title = modelData.title;
    this.sp = modelData.sp;
  }
}
